const BASE_API = `${process.env.NEXT_PUBLIC_RM_BASE_API}/api`

export interface ContactFormPayload {
    lastName: string
    firstName: string
    email: string
    message: string
    subject: string
    question?: string
    subjectData: {
        value: string
        label: string
        info: string
        question?: string
    }
    turnstile_token?: string | null
}

export async function postContactForm(payload: ContactFormPayload): Promise<Response> {
    return fetch(`${BASE_API}/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
        cache: "no-store",
    })
}
